import type { TextSentTimelineEntry } from '@kizen/api';
import type { CardHeaderConfig } from '../components/CardHeader';

import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import { CardHeader } from '../components/CardHeader';
import { defaultAutomationString, defaultEmployeeString } from '../helpers';
import BasicBlock from '../components/BasicBlock';
import LongTextEllipsis from '../LongTextEllipsis';
import TypeIcon from '../TypeIcon';

type TextSentProps = {
  business?: never;
  commentOpenDefault?: boolean;
  event: SnakeToCamelCase<TextSentTimelineEntry>;
  index: number;
  mobileOverride?: boolean;
  onComment(comment: string): void;
  onDelete?(): void;
};

const getConfig = (
  t: (x: string) => string,
  _event: TextSentProps['event']
): CardHeaderConfig => {
  return {
    automation: {
      prefix: t('via'),
      creationType: defaultAutomationString,
    },
    employee: {
      prefix: t('by'),
      creationType: defaultEmployeeString,
    },
  };
};

export const TextSent = (props: TextSentProps) => {
  const {
    commentOpenDefault = false,
    event,
    index,
    mobileOverride = false,
    onComment,
    onDelete,
  } = props;

  const { t } = useTranslation();

  const icon = (
    <TypeIcon
      color="var(--color-viz-cat-2-primary)"
      icon="mobile"
      size="16px"
    />
  );

  const title = (
    <CardHeader event={event} name={event.typeDisplayName} config={getConfig} />
  );

  return (
    <BasicBlock
      event={event}
      icon={icon}
      index={index}
      title={title}
      comments={event.comments}
      commentOpenDefault={commentOpenDefault}
      mobileOverride={mobileOverride}
      timestamp={event.created}
      onComment={onComment}
      onDelete={onDelete}
    >
      <KizenTypography weight="bold">{t('Message')}</KizenTypography>
      <LongTextEllipsis isExpandable>{event.data.content}</LongTextEllipsis>
    </BasicBlock>
  );
};
